import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './shared/header/header';
import { FooterComponent } from './shared/footer/footer';
import { LoggerService } from './core/services/logger.service';
import { NavigationTimingService } from './core/services/navigation-timing.service';
import { LoadingComponent } from './shared/loading/loading';
import { ConfirmationComponent } from './shared/confirmation/confirmation';
import { ApiErrorBannerComponent } from './shared/api-error-banner/api-error-banner';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    LoadingComponent,
    ConfirmationComponent,
    ApiErrorBannerComponent
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class AppComponent implements OnInit {
  private readonly logger = inject(LoggerService);
  private readonly navTiming = inject(NavigationTimingService);

  ngOnInit(): void {
    this.navTiming.init();
    this.logger.info('AppComponent', 'App component initialised');
  }
}
